<app-patient-side-nav></app-patient-side-nav>

<div class="content">
	<app-patient-details></app-patient-details>

	<app-patient-nav></app-patient-nav>

	<div class="outlet">
		<router-outlet></router-outlet>
	</div>
</div>
